export default "__VITE_ASSET__5bb77524__"